import { format, parseISO } from 'date-fns'

export const formatMdxDate = (date?: string): string =>
  date ? format(parseISO(date), 'd MMM, yyyy') : ''
